import React, { useCallback, useRef, useEffect } from 'react';

import Button from '@material-ui/core/Button';
import VideoOffIcon from '../../../icons/VideoOffIcon';
import VideoOnIcon from '../../../icons/VideoOnIcon';

import useDevices from '../../../hooks/useDevices/useDevices';
import useLocalVideoToggle from '../../../hooks/useLocalVideoToggle/useLocalVideoToggle';
import useChatContext from '../../../hooks/useChatContext/useChatContext';
import useParticipants from '../../../hooks/useParticipants/useParticipants';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

export default function ToggleVideoButton(props: { disabled?: boolean; className?: string }) {
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
  const { localTracks, room } = useVideoContext();
  const lastClickTimeRef = useRef(0);
  const { hasVideoInputDevices } = useDevices();
  const participants = useParticipants();
  const { messages } = useChatContext();
  useEffect(() => {
    //console.log(participants);
    //console.log(room?.localParticipant);
    if (messages.length > 0 && room?.localParticipant != null) {
      //console.log(messages[messages.length - 1]?.body?.split('/')[1], 'checking wala data');
      if (
        messages[messages.length - 1]?.body?.split('/')[0] == 'video' &&
        messages[messages.length - 1]?.body?.split('/')[1] == room?.localParticipant.sid
      ) {
        toggleVideo();
      }
    }
  }, [messages]);
  const toggleVideo = useCallback(() => {
    if (Date.now() - lastClickTimeRef.current > 500) {
      lastClickTimeRef.current = Date.now();
      toggleVideoEnabled();
    }
  }, [toggleVideoEnabled]);

  return (
    <Button
      className={props.className}
      onClick={toggleVideo}
      disabled={!hasVideoInputDevices || props.disabled}
      startIcon={isVideoEnabled ? <VideoOnIcon /> : <VideoOffIcon />}
    >
      <span className="formobs">
        {' '}
        {!hasVideoInputDevices ? 'No Video' : isVideoEnabled ? 'Stop Video' : 'Start Video'}
      </span>
    </Button>
  );
}
